import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "40px", paddingTop: "120px", maxWidth: "900px", margin: "0 auto", fontFamily: "DM Sans, sans-serif", lineHeight: "1.7", color: "#333" }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: October 2025</p>

      <p>
        HelloParyatak ("we", "our", "us") values your privacy and is committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website or use our services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following information from users:</p>
      <ul>
        <li>Personal information: Name, email, phone number, address, and other contact details provided while booking or contacting us.</li>
        <li>Non-personal information: Browser type, device information, IP address, pages visited, and interactions on our website.</li>
        <li>Payment information: Card details and transaction information via secure third-party gateways.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use collected information for the following purposes:</p>
      <ul>
        <li>To provide, maintain, and improve our services.</li>
        <li>To process bookings, inquiries, and payments securely.</li>
        <li>To communicate promotional offers, updates, and notifications (only if consented).</li>
        <li>To personalize your experience on our website.</li>
      </ul>

      <h2>3. Cookies and Tracking</h2>
      <p>We use cookies and similar technologies to analyze website traffic, improve user experience, and for marketing purposes. You can manage or disable cookies through your browser settings.</p>

      <h2>4. Data Sharing</h2>
      <p>We do not sell, trade, or rent users’ personal information to third parties. We may share information with:</p>
      <ul>
        <li>Service providers for payment processing, email communication, and analytics.</li>
        <li>Legal authorities if required by law or to protect our rights.</li>
      </ul>

      <h2>5. Data Security</h2>
      <p>We implement reasonable administrative, technical, and physical safeguards to protect your personal information from unauthorized access or disclosure. However, no method of transmission over the Internet is 100% secure.</p>

      <h2>6. Your Rights</h2>
      <p>You have the right to access, correct, or request deletion of your personal information. You can also unsubscribe from promotional communications at any time.</p>

      <h2>7. Changes to this Privacy Policy</h2>
      <p>We may update this Privacy Policy periodically. Changes will be posted on this page with the effective date. Please review it regularly.</p>

      <h2>8. Contact Us</h2>
      <p>For questions or concerns regarding this Privacy Policy, please contact us at <a href="mailto:info@helloparyatak.com">info@helloparyatak.com</a>.</p>
    </div>
  );
};

export default PrivacyPolicy;
